import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { toast } from "sonner";
import { getLeadTracking, trackLeadDeduped } from "../lib/fbpixel";
import { trackGaLead } from "../lib/ga";
import ConsentField from "./ConsentField";
import { trackFormStart } from "../lib/formTracking";

export default function LeadForm({ leadType = "general", source = "", title = "Request a Consultation", compact = false }) {
  const [form, setForm] = useState({ name: "", email: "", phone: "", address: "", message: "" });
  const [marketing, setMarketing] = useState(false);
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    try {
      const tracking = getLeadTracking();
      await api.post("/leads", { ...form, lead_type: leadType, source_page: source, marketing_consent: marketing, ...tracking });
      trackLeadDeduped(tracking.event_id, { content_category: leadType, source_page: source });
      trackGaLead({ lead_type: leadType, source_page: source });
      toast.success("Thank you. We will be in touch within 24 hours.");
      setForm({ name: "", email: "", phone: "", address: "", message: "" });
    } catch {
      toast.error("Submission failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const input = "w-full bg-[#151515] border border-[#D8D6D0]/20 px-4 py-3 text-sm text-[#F5F3EF] placeholder:text-[#D8D6D0]/40 focus:outline-none focus:border-[#F5F3EF]/70 transition-colors duration-300";

  return (
    <form onSubmit={submit} data-testid={`lead-form-${leadType}`} className="space-y-4">
      {!compact && <div className="font-serif-display text-3xl mb-2">{title}</div>}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <input data-testid="lead-name" required placeholder="Name" className={input} value={form.name} onFocus={() => trackFormStart(`contact-${leadType}`)} onChange={(e) => setForm({ ...form, name: e.target.value })} />
        <input data-testid="lead-email" required type="email" placeholder="Email" className={input} value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <input data-testid="lead-phone" required minLength={7} pattern="[0-9\s\(\)\+\.\-]{7,}" title="Please enter a valid phone number" placeholder="Phone" className={input} value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
        <input data-testid="lead-address" placeholder="Project Address (optional)" className={input} value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} />
      </div>
      <textarea data-testid="lead-message" rows={4} placeholder="Tell us about your project" className={input} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} />
      <ConsentField checked={marketing} onChange={setMarketing} testId="lead-consent-marketing" />
      <button
        type="submit"
        disabled={loading}
        data-testid="lead-submit"
        className="w-full md:w-auto px-8 py-4 bg-[#8C1D30] hover:bg-[#7A1829] text-[#F5F3EF] text-sm tracking-wider uppercase transition-colors duration-300 disabled:opacity-50"
      >
        {loading ? "Sending…" : "Submit Request"}
      </button>
    </form>
  );
}
